var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkStarClicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7884 9.27711C35.0313 2.40872 25.2797 2.46395 23.3756 9.35875L20.8585 18.4728L11.1916 18.5276C3.7498 18.5698 1.3276 28.1515 7.69234 32.3697L15.5773 37.5954L13.1733 46.3C11.2522 53.2559 19.5118 59.1208 25.2716 54.8907L33.0519 49.1766L41.5348 54.7986C47.8146 58.9605 55.3418 53.0061 52.5603 46.0769L49.0795 37.4056L56.3115 32.0943C62.1492 27.807 58.5416 18.2594 51.0998 18.3015L41.4329 18.3563L37.7884 9.27711Z",
    fill: "#FF9BD0",
    stroke: "white",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkStarClicked);
export default __webpack_public_path__ + "static/media/pinkStarClicked.6af19b41542f8cd56d9576519b2fcff9.svg";
export { ForwardRef as ReactComponent };